module.exports = __webpack_public_path__ + "img/icon_qfqz.827ca3ca.png";